import { Reducer } from "../../lib/redux";
import { IMessage } from "../../model/Message";
import { extend } from "../../utils/vanilla";
import { MessageActions } from "./actions";
import { MessageActionTypes } from "./types";

export let defaultMessages: IIdDictionary<IIdDictionary<IMessage>> = {};

export let messages: Reducer<IIdDictionary<IIdDictionary<IMessage>>, MessageActions> = (state = defaultMessages, action) => {
    switch (action.type) {
        case MessageActionTypes.SET_MESSAGES: {
            const userId = action.payload.userId;
            const msgs = action.payload.messages ? extend(true, {}, action.payload.messages) :  {};
            if (userId) {
                return {
                    ...state,
                    [userId]: msgs
                };
            }
            return state;
        }
        case MessageActionTypes.CLEAR_MESSAGES: {
            const userId = action.payload.userId;
            if (userId) {
                let newState = { ...state };
                delete newState[userId];
                return newState;
            }
            return defaultMessages;
        }
        default:
            return state;
    }
};

/**
 * Content-free change signal for DriveNative's TextMessage cache refresh.
 *
 * The native bridge observes this scalar instead of the `messages` slice, so
 * dispatcher content never crosses the WebView boundary. Each legacy message
 * replacement/clear advances the revision and lets native fetch authoritative
 * rows through its own TextMessage sync.
 */
export let messageRevision: Reducer<number, MessageActions> = (state = 0, action) => {
    switch (action.type) {
        case MessageActionTypes.SET_MESSAGES:
        case MessageActionTypes.CLEAR_MESSAGES:
            return state === Number.MAX_SAFE_INTEGER ? 0 : state + 1;
        default:
            return state;
    }
};
